import {
    Alert,
    Button, Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Paper,
    Select,
    TextField
} from "@mui/material";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";  // Import the DataGrid component
import Title from "../Title";
import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import Api from "../../Services/Api";
import AlertsDashboard from "./AlertsDashboard";
import SupplyFeedDetailsTable from "./SupplyFeedDetailsTable";
import IconButton from "@mui/material/IconButton";
import {Edit, NoteAdd, QueryStats} from "@mui/icons-material";
import DialogContentText from "@mui/material/DialogContentText";
import '../../own.css'

const FeedAlerts = () => {
    const [dataAlerts, setDataAlerts] = React.useState([]);
    const [openQuickStats, setOpenQuickStats] = React.useState(false);
    const [quickStatsSupplyFeedId, setQuickStatsSupplyFeedId] = React.useState(null);
    const [quickStatsDemandFeedId, setQuickStatsDemandFeedId] = React.useState(null);


    const [category, setCategory] = React.useState(null);

    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState('');
    const [note, setNote] = React.useState('');
    const [editingRow, setEditingRow] = React.useState(null);
    const [recentlyEditedRowId, setRecentlyEditedRowId] = React.useState(null);


    useEffect(() => {
        Api.adminAlerts().then(r => {
            setDataAlerts(r);
        });
    }, []);

    // Define the columns for the DataGrid
    const columns = [
        {field: 'id', headerName: 'ID', flex: 0.1, minWidth: 70},
        {field: 'type', headerName: 'Type', flex: 0.7, minWidth: 100},
        {
            field: 'priority', headerName: 'Priority', flex: 0.5, minWidth: 100, renderCell: (params) => (

                params.row.priority == "urgent" ?
                    (
                        <>🔥🔥🔥</>
                    ) :
                    (
                        <>🔥🔥</>
                    )
            )
        },
        {field: 'category', headerName: 'Category', flex: 1, minWidth: 150},
        {field: 'status', headerName: 'Status', flex: 0.5, minWidth: 75},
        {field: 'demand_feed_id', headerName: 'D. Feed Id', flex: 0.75, minWidth: 100},
        {field: 'supply_feed_id', headerName: 'S. Feed Id', flex: 0.75, minWidth: 100},
        {
            field: 'pair',
            headerName: 'Pair',
            flex: 1.5,
            minWidth: 300,
            valueGetter: (params) => params.row.supply_user.name+'-'+params.row.demand_user.name,
            renderCell: (params) => (
                <div>

                    <Chip
                        label={params.row.supply_user.name}
                        style={{backgroundColor: stringToColor(params.row.supply_user.name), color: '#fff'}}
                        size={"small"}
                    />
                     &nbsp; → &nbsp;
                    <Chip
                        label={params.row.demand_user.name}
                        style={{backgroundColor: stringToColor(params.row.demand_user.name), color: '#fff'}}
                        size={"small"}
                    />

                </div>
            )
        },

        {
            field: 'demand_type',
            headerName: 'Demand Type',
            flex: 0.75,
            minWidth: 150,
            valueGetter: (params) => params.row.demand_feed.type.name,

        },
        {
            field: 'needle',
            headerName: 'Needle',
            flex: 0.75,
            minWidth: 150,
            valueGetter: (params) => params.row.demand_feed.needle
        },
        {field: 'date', headerName: 'Issue Date', flex: 0.75, minWidth: 120},

        {field: 'description', headerName: 'Description', flex: 3, minWidth: 450},
        {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            flex: 1,
            minWidth: 200,
            renderCell: (params) => (
                <div>
                    <IconButton
                        onClick={() => {
                            setQuickStatsSupplyFeedId(params.row.supply_feed_id)
                            setQuickStatsDemandFeedId(params.row.demand_feed_id)
                            setOpenQuickStats(true)
                        }}
                        size="small"
                        color="primary"
                    >
                        <QueryStats/>
                    </IconButton>

                    <IconButton
                        onClick={() => {
                            setEditingRow(params.row);
                            setOpenDialog(true);
                        }}
                        sx={{ml: 1}}
                        size="small"
                        color="primary"
                        disabled={params.row.category != "missing_demand_data"}

                    >
                        <NoteAdd/>
                    </IconButton>


                </div>
            ),
        },
        // Add more columns as needed...
    ];

    const stringToColor = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        // Convert the hash to a Hue value
        let hue = hash % 360;

        // Return as a HSL color. Adjust the Saturation and Lightness to taste
        return `hsl(${hue}, 60%, 50%)`;
    }


    const handleClose = () => {
        setOpenDialog(false);
    }

    const handleSave = () => {
        Api.addNoteFeedAlert({id: editingRow.id, note}).then((updatedRow) => {
            setRecentlyEditedRowId(updatedRow.id);

            // Replace the edited row in the state
            setDataAlerts(prevDataAlerts =>
                prevDataAlerts.map(alert =>
                    alert.id === updatedRow.id ? updatedRow : alert
                )
            );
            setTimeout(() => setRecentlyEditedRowId(null), 2000);  // Clear after 2 seconds

            setNote('')
        });
        setOpenDialog(false);
    };


    return (
        <MainLayout>
            <Container maxWidth="2xl" sx={{mt: 4, mb: 4}}>
                <SupplyFeedDetailsTable supplyFeedId={quickStatsSupplyFeedId} demandFeedId={quickStatsDemandFeedId} open={openQuickStats} setOpen={setOpenQuickStats}/>
                <Dialog open={openDialog} onClose={handleClose}>
                    <DialogTitle>Add Note</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" sx={{mb: 2}}>
                            <Alert severity="warning">This Alert will be marked as <strong>SOLVED</strong>, please add a
                                note explaining how you solved it. </Alert>

                        </DialogContentText>
                        <TextField
                            label="Note"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            multiline
                            fullWidth
                            rows={6} // Increase the size of text area by increasing the number of rows
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button onClick={handleSave}>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
                <Paper sx={{p: 2}}>
                    <Title>Alerts</Title>
                    <AlertsDashboard data={dataAlerts} setCategory={setCategory}/>

                    <div style={{minHeight: 400, width: "100%"}}>
                        <DataGrid
                            rows={category ? dataAlerts.filter(alert => alert.category === category) : dataAlerts}
                            columns={columns}
                            pageSize={500}

                            components={{
                                Toolbar: GridToolbar,

                            }}
                            getRowClassName={(params) =>
                                params.id === recentlyEditedRowId ? 'edited-row' : ''
                            }
                            density={"compact"}

                            componentsProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: {debounceMs: 500},
                                },
                            }}/>
                    </div>
                </Paper>
            </Container>
        </MainLayout>
    );
}

export default FeedAlerts;
